<template>
  <div>
    <v-navigation-drawer
      app
      mini-variant
      style="z-index: 3;"
      color="#fff"
      disable-resize-watcher
      mobile-breakpoint="0"
    >
      <v-list
        nav
        dense
        style="position: relative;"
        class="pb-12"
        rounded
        dark
      >
        <v-list-item
          class="mb-2 bg-custom-default"
          :disabled="rect_count >= max_rect" 
          link
          :title="`Додати карту (${rect_count}/${max_rect})`"
        >
          <c-rect-create class="v-list-item_custom">
            <v-list-item-icon>
              <v-icon>mdi-arrow-decision-outline</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Додати карту ({{ rect_count }}/{{ max_rect }})</v-list-item-title>
          </c-rect-create>
        </v-list-item>

        <v-list-item
          class="mb-2 bg-custom-default"
          link
          title="Налаштування"
        >
          <div class="v-list-item_custom">
            <v-list-item-icon @click="openModalSettings()">
              <v-icon>tune</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Налаштування</v-list-item-title>
          </div>
        </v-list-item>

        <v-list-item
          class="mb-2 bg-custom-default"
          link
          title="Інструкція"
          style="position: fixed; bottom: 50px; width: calc(100% - 16px);"
        >
          <div class="v-list-item_custom">
            <v-list-item-icon>
              <a
                  href="https://docs.google.com/document/d/1BsW5s52EzybsjlDaC91Wxr-lMavJQQZnhDqUU_kdAuE/edit?pli=1#heading=h.tot7dckzdzzs"
                  target="_blank"
              ><v-icon style="margin-top: -3px;">help</v-icon></a>
            </v-list-item-icon>
            <v-list-item-title>Інструкція</v-list-item-title>
          </div>
        </v-list-item>

        <v-list-item
          :title='`Вийти з акаунту "${user.username}"`'
          link
          @click="openModalLogout()"
          style="position: fixed; bottom: 10px; width: calc(100% - 16px);"
          class="bg-custom-default"
        >
          <v-list-item-icon>
            <v-icon>exit_to_app</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Вийти</v-list-item-title>
        </v-list-item>

      </v-list>
    </v-navigation-drawer>

    <c-settings-modal ref="c-settings-modal"/>
    <c-confirm-modal
        ref="c-confirm-modal"
        message="Ви впевнені, що хочете вийти?"
        @handleOk="handleOk"
        @handleClose="handleClose"
    />
  </div>
</template>

<script>
import cRectCreate from '@/components/rect/c-rect-create'
import cSettingsModal from '@/components/base/c-settings-modal'
import cConfirmModal from '@/components/base/c-confirm-modal'

import { config_rect } from '@/config'
export default {
  name: 'c-nav-drawer',
  components: {
    cRectCreate,
    cSettingsModal,
    cConfirmModal
  },
  data() {
    return {
      max_rect: config_rect.max_count
    }
  },
  computed: {
    user() {
      return this.$store.getters.AUTH_USER
    },
    rect_count() {
      return this.$store.getters.RECT_LIST.length
    }
  },
  methods: {
    openModalSettings() {
      this.$refs['c-settings-modal'].openModal()
    },
    openModalLogout() {
      this.$refs['c-confirm-modal'].openModal()
    },
    handleOk() {
      this.$emit('logout')
    },
    handleClose() {
      this.modal = {}
    }
  }
}
</script>

<style lang="scss">
  .bg-custom-default {
    &.v-list-item--disabled {
      opacity: .6;
    }
  }
</style>